import type { SharePointLocation } from './types';

// Browser-only: a remembered folder is a convenience, so losing it just starts at the OneDrive root.
const storageKey = (user: string, templateId: string) => `rc.lastOneDriveFolder.${user.toLowerCase()}.${templateId}`;

export function readLastOneDriveFolder(user: string, templateId: string): SharePointLocation | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(storageKey(user, templateId)) ?? 'null') as SharePointLocation | null;
    return parsed && typeof parsed.driveId === 'string' && Array.isArray(parsed.folders) ? parsed : null;
  } catch {
    return null;
  }
}

export function rememberLastOneDriveFolder(user: string, templateId: string, location: SharePointLocation): void {
  try {
    localStorage.setItem(storageKey(user, templateId), JSON.stringify(location));
  } catch {
    // Storage can be full or blocked; nothing depends on it.
  }
}
